//该文件用于创建Vuex中最为核心的store
import Vue from 'vue'
//引入Vuex
import Vuex from 'vuex'
import tab from './tab';
//应用Vuex插件
Vue.use(Vuex)

//创建并暴露store
export default new Vuex.Store({
  state: {
    toolbar: JSON.parse(sessionStorage.getItem("toolbar") || '{"visible": false, "enter": false}'),
    sortInfo: JSON.parse(sessionStorage.getItem("sortInfo") || '[]'),
    currentUser: JSON.parse(sessionStorage.getItem("currentUser") || '{}'),
    currentAdmin: JSON.parse(sessionStorage.getItem("currentAdmin") || '{}'),
    webInfo: JSON.parse(sessionStorage.getItem("webInfo") || '{"webName": "", "webTitle": [], "notices": [], "footer": "", "backgroundImage": "", "avatar": ""}'),
    questionMessages: JSON.parse(sessionStorage.getItem("questionMessages") || '[]'),
    questionFile: JSON.parse(sessionStorage.getItem("questionFile") || 'null'),
    // reading: JSON.parse(sessionStorage.getItem("reading") || '{false}'),
  },
  getters: {
    articleTotal: state => {
      if (state.sortInfo !== null && state.sortInfo.length !== 0) {
        if (state.sortInfo.length === 1) {
          return state.sortInfo[0].countOfSort;
        } else {
          return state.sortInfo.reduce((prev, curr) => {
            if (typeof prev === "number") {
              return prev + curr.countOfSort;
            } else {
              return prev.countOfSort + curr.countOfSort;
            }
          });
        }
      } else {
        return 0;
      }
    },
    navigationBar: state => {
      if (state.sortInfo !== null && state.sortInfo.length !== 0) {
        return state.sortInfo.filter(f => f.sortType === 0);
      } else {
        return [];
      }
    }
  },
  mutations: {
    changeToolbarStatus(state, toolbarState) {
      state.toolbar = toolbarState;
      sessionStorage.setItem("toolbar", JSON.stringify(toolbarState));
    },
    loadSortInfo(state, sortInfo) {
      if (sortInfo !== null && sortInfo.length !== 0) {
        state.sortInfo = sortInfo.sort((s1, s2) => s1.priority - s2.priority);
        sessionStorage.setItem("sortInfo", JSON.stringify(sortInfo.sort((s1, s2) => s1.priority - s2.priority)));
      }
    },
    loadCurrentUser(state, user) {
      state.currentUser = user;
      sessionStorage.setItem("currentUser", JSON.stringify(user));
    },
    loadCurrentAdmin(state, user) {
      state.currentAdmin = user;
      sessionStorage.setItem("currentAdmin", JSON.stringify(user));
    },
    loadWebInfo(state, webInfo) {
      webInfo.webTitle = webInfo.webTitle.split('');
      webInfo.notices = JSON.parse(webInfo.notices);
      state.webInfo = webInfo;
      sessionStorage.setItem("webInfo", JSON.stringify(webInfo));
    },
    changeReadingStatus(state, readingStatus) {
      state.reading = readingStatus;
      sessionStorage.setItem("reading", JSON.stringify(readingStatus));
    },
    loadQuestionMessages(state, messages) {
      state.questionMessages = messages;
      sessionStorage.setItem("questionMessages", JSON.stringify(messages));
    },
    loadQuestionFile(state, file) {
      state.questionFile = file;
      sessionStorage.setItem("questionFile", JSON.stringify(file));
    }
  },
  modules: {
    tab,
  }
})